import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'OrganizedUnit/AllWhitLegaForUser', method: 'GET', body: null, token: token })
}
